import * as types from './types';
import {
  loadNoteFiltersFromStorage,
  saveNoteFiltersToStorage,
} from './storage';
import { selectNoteTypeFilters } from './selectors';

export const DEFAULT_NOTE_TYPE_FILTERS = [
  'Note',
  'Medical',
  'Competition',
  'TackEquipment',
  'Billing',
  'Farrier',
];

const cloneFilters = (filters) => {
  if (!filters) return [];
  return [...filters];
};

export const initializeNoteTypeFilter = ({
  userId,
  fallback,
}) => (dispatch, getState) => {
  const existing = selectNoteTypeFilters(getState());
  if (existing && existing.length) return;

  const storedFilters = loadNoteFiltersFromStorage(userId);
  const resolvedFilters = (storedFilters && storedFilters.length)
    ? storedFilters
    : cloneFilters(fallback || DEFAULT_NOTE_TYPE_FILTERS);

  dispatch({
    type: types.SET_NOTE_TYPE_FILTER,
    payload: { value: resolvedFilters },
  });

  if (!storedFilters || storedFilters.length === 0) {
    saveNoteFiltersToStorage(userId, resolvedFilters);
  }
};

export const updateNoteTypeFilter = ({
  userId,
  value,
}) => (dispatch) => {
  const resolvedValue = cloneFilters(value);

  dispatch({
    type: types.SET_NOTE_TYPE_FILTER,
    payload: { value: resolvedValue },
  });

  saveNoteFiltersToStorage(userId, resolvedValue);
};

export const resetNoteTypeFilters = () => ({ type: types.RESET_NOTE_TYPE_FILTERS });
